import { useTranslation } from 'react-i18next';

function ProfileEmailAndPasswordPage() {
  const { t } = useTranslation();
  return <h1>{t('pages.profile_email_and_password.title')}</h1>;
}

export default ProfileEmailAndPasswordPage;
